import Vue from 'vue';
import App from './App.vue';
import VueModal from '@kouts/vue-modal';

import '@kouts/vue-modal/dist/vue-modal.css';
import '@oeamtc/styleguide-base-css/dist/prefixed.css';
import './css/lib.scss';

Vue.config.productionTip = false;

Vue.component('ModalItem', VueModal);

new Vue({
  render: (h) => h(App),
}).$mount('#nothilfe-app');
